import {defineMessages} from 'react-intl';

export default defineMessages({
  completedSkillsMessage: {
    defaultMessage: '{completedItems} of {totalItems} completed',
    id: 'LandingPage.CurriculumSection.CompletedSkillsMessage',
  },
});
